import {
  type TriggerEvaluationRecord,
  TriggerEvaluationOutcome,
  TriggerEvaluationOutcomeReason,
} from "@/shared/domain/actions";

export type EvaluationColumn = keyof TriggerEvaluationRecord | "dataset_id";

export const DEFAULT_EVALUATION_COLUMNS: EvaluationColumn[] = [
  "trigger_id",
  "cause",
  "data_source",
  "evaluation_start",
  "evaluation_end",
  "status",
  "status_detail",
  "outcome",
  "outcome_reason",
];

export function outcomeToFormattedString(
  outcome?: TriggerEvaluationOutcome,
): string {
  switch (outcome) {
    case TriggerEvaluationOutcome.InvokedAction:
      return "Invoked Action";
    case TriggerEvaluationOutcome.Skipped:
      return "Skipped";
    default:
      return "-";
  }
}

export function outcomeReasonToFormattedString(
  outcomeReason?: TriggerEvaluationOutcomeReason,
): string {
  switch (outcomeReason) {
    case TriggerEvaluationOutcomeReason.AlreadyRun:
      return "Already Run";
    case TriggerEvaluationOutcomeReason.ConditionNotMet:
      return "Condition Not Met";
    case TriggerEvaluationOutcomeReason.NoMatchingFiles:
      return "No Matching Files";
    case TriggerEvaluationOutcomeReason.TriggerDisabled:
      return "Trigger Disabled";
    default:
      return "-";
  }
}
